export enum Status {
  PendingReceipt = 1,
  PendingPackage = 2,
  PendingPlan = 3,
  PendingShipment = 4,
  Shipped = 5,
  NeedsReview = 6,
  WarehouseReview = 7,
  TrustBox = 8,
}
